/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SecurityInputs */

const th_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความปลอดภัย`)
};

const en_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const ja_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティ`)
};

const zh_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全`)
};

const es_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguridad`)
};

const pt_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurança`)
};

const id_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keamanan`)
};

const fr_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité`)
};

const tl_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguridad`)
};

const vi_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảo mật`)
};

const ko_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안`)
};

const de_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit`)
};

const ru_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасность`)
};

const tr_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik`)
};

const it_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicurezza`)
};

const pl_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpieczeństwo`)
};

const uk_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безпека`)
};

const hi_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुरक्षा`)
};

const ar_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأمان`)
};

const ms_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keselamatan`)
};

const bn_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিরাপত্তা`)
};

const zh_tw2_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全性`)
};

const zh_hk2_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全性`)
};

const ur_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سیکیورٹی`)
};

const fa_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امنیت`)
};

const sw_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usalama`)
};

const nl_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beveiliging`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {SecurityInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const security = /** @type {((inputs?: SecurityInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SecurityInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_security(inputs)
	if (locale === "ja") return ja_security(inputs)
	if (locale === "zh") return zh_security(inputs)
	if (locale === "es") return es_security(inputs)
	if (locale === "pt") return pt_security(inputs)
	if (locale === "id") return id_security(inputs)
	if (locale === "fr") return fr_security(inputs)
	if (locale === "tl") return tl_security(inputs)
	if (locale === "vi") return vi_security(inputs)
	if (locale === "ko") return ko_security(inputs)
	if (locale === "de") return de_security(inputs)
	if (locale === "ru") return ru_security(inputs)
	if (locale === "tr") return tr_security(inputs)
	if (locale === "it") return it_security(inputs)
	if (locale === "pl") return pl_security(inputs)
	if (locale === "uk") return uk_security(inputs)
	if (locale === "hi") return hi_security(inputs)
	if (locale === "ar") return ar_security(inputs)
	if (locale === "ms") return ms_security(inputs)
	if (locale === "bn") return bn_security(inputs)
	if (locale === "zh-TW") return zh_tw2_security(inputs)
	if (locale === "zh-HK") return zh_hk2_security(inputs)
	if (locale === "ur") return ur_security(inputs)
	if (locale === "fa") return fa_security(inputs)
	if (locale === "sw") return sw_security(inputs)
	if (locale === "nl") return nl_security(inputs)
	return en_security(inputs)
});